import {
  ThemeProvider as LibThemeProvider,
  OverwrittenColors,
  createThemes,
  useTheme as useLibTheme,
} from "@flaminem/ui-components";
export type { Theme, ThemeColors, ThemeSpacing } from "@flaminem/ui-components";
import { FC, ReactNode } from "react";

export type ThemeProviderProps = {
  children: ReactNode;
};

const overwrittenColors = {
  background: {
    brand: "#0f62fe",
  },
  focus: {
    index: "#ffcd00",
    inverse: "#ffcd00",
  },
  text: {
    highlight: "#ffcd00",
  },
  link: {
    inverse: "#ffcd00",
  },
  border: {
    interactive: "#ffcd00",
  },
  icon: {
    interactive: "#ffcd00",
  },
  interactive: "#ffcd00",
} satisfies OverwrittenColors;

const themes = createThemes({
  white: {
    colors: overwrittenColors,
  },
  g10: {
    colors: overwrittenColors,
  },
  g90: {
    colors: overwrittenColors,
  },
  g100: {
    colors: overwrittenColors,
  },
});

export const ThemeProvider: FC<ThemeProviderProps> = ({ children }) => {
  return (
    <LibThemeProvider themes={themes} defaultTheme="white" storageKey="flaminem:theme">
      {children}
    </LibThemeProvider>
  );
};

export const useTheme = useLibTheme;
